import axios from "axios";
import { message } from "antd";
import { t } from "i18next";

import countryLangStore, { defaultUser } from "@zustand/countryLang";
import { checkEmptyString } from "./checkEmpty";

export const checkUserInfo = async (token: string) => {
  const headersBearer = `Bearer ${token}`;
  const headers = {
    Authorization: headersBearer,
  };

  return axios({
    method: "POST",
    url: process.env.REACT_APP_KEYCLOAK_URL_GET_INFO,
    headers: headers,
  })
    .then((res) => {
      countryLangStore.getState().setUser({
        ...countryLangStore.getState().user,
        isLogin: true,
        ...res.data,
      });
      return { status: true, message: res?.data };
    })
    .catch((err) => {
      return { status: false, message: err };
    });
};

export const handleUserInfo = async (bearer_token: string) => {
  const userInfo = await checkUserInfo(checkEmptyString(bearer_token));
  if (userInfo?.status === false) {
    countryLangStore.getState().setUser({
      ...defaultUser,
      isLogin: false,
    });
    message.error(`${t("Common:error")}${String(userInfo.message)}`);
  }
};

export const getUserInfo = async (token: string) => {
  const headersBearer = `Bearer ${token}`;
  const headers = {
    Authorization: headersBearer,
  };

  return axios({
    method: "POST",
    url: process.env.REACT_APP_KEYCLOAK_URL_GET_INFO,
    headers: headers,
  })
    .then((res) => {
      return { status: true, message: res };
    })
    .catch((err) => {
      return { status: false, message: err };
    });
};
